// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EvidencijaPolaznika_search__iKbFK {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  border-bottom: 1px solid #d1d9e2;
  padding-bottom: 20px;
  margin-bottom: 50px;
}

.EvidencijaPolaznika_label__4QwR8 {
  border: 1px solid #d8dbdf;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 46px;
  padding: 0 15px;
  width: 25%;
  border-radius: 8px;
  box-shadow: 0px 0px 50px 0px #5f6d7e1a;
}

.EvidencijaPolaznika_input__Q9jCh {
  border: none;
  font-size: 16px;
  font-weight: 500;
  font-family: "Inter";
  color: #5f6d7e;
  width: 90%;
}

.EvidencijaPolaznika_input__Q9jCh::placeholder {
  font-size: 16px;
  font-weight: 500;
  font-family: "Inter";
  color: #9fa7b2;
}

.EvidencijaPolaznika_input__Q9jCh:focus {
  outline: none;
}

.EvidencijaPolaznika_searchLabel__OCt21 {
  font-size: 20px;
  font-weight: 600;
  font-family: "Inter";
  color: #4d4d4d;
}

.EvidencijaPolaznika_info__6Tufv {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: #ffebeb;
  border-radius: 8px;
  padding: 0 20px;
}

.EvidencijaPolaznika_infoP__-LktI {
  font-size: 14px;
  font-weight: 500;
  font-family: "Inter";
  color: #5f6d7e;
}

.EvidencijaPolaznika_input__Q9jCh::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

.EvidencijaPolaznika_searchContainer__2BSVK {
  width: 100%;
}

.EvidencijaPolaznika_dropdown__yqt33 {
  width: 19.6%;
  margin-top: 10px;
  position: absolute;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px 5px #5f6d7e1a;
}

.EvidencijaPolaznika_dropdown__yqt33:hover {
  cursor: pointer;
}

.EvidencijaPolaznika_dropdownItem__pqSwh {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 15px;
  width: 91%;
  height: 30px;
}

.EvidencijaPolaznika_dropdownItem__pqSwh:hover {
  background-color: #f2f2f2;
}

.EvidencijaPolaznika_p__uA5Mo {
  font-size: 16px;
  font-weight: 500;
  font-family: "Inter";
  color: #5f6d7ec7;
}

@media screen and (max-width: 1400px) {
  .EvidencijaPolaznika_dropdown__yqt33 {
    width: 18%;
  }
}

@media screen and (max-width: 1280px) {
  .EvidencijaPolaznika_dropdown__yqt33 {
    width: 23%;
  }
}

@media screen and (max-width: 1000px) {
  .EvidencijaPolaznika_dropdown__yqt33 {
    width: 30%;
  }
  .EvidencijaPolaznika_label__4QwR8 {
    width: 34%;
  }
}

@media screen and (max-width: 700px) {
  .EvidencijaPolaznika_dropdown__yqt33 {
    width: 38%;
  }
  .EvidencijaPolaznika_label__4QwR8 {
    width: 45%;
  }
}

@media screen and (max-width: 500px) {
  .EvidencijaPolaznika_dropdown__yqt33 {
    width: 65%;
  }
  .EvidencijaPolaznika_label__4QwR8 {
    width: 90%;
  }
}

@media screen and (max-width: 380px) {
  .EvidencijaPolaznika_dropdown__yqt33 {
    width: 63%;
  }
  .EvidencijaPolaznika_label__4QwR8 {
    width: 89%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencijaPolaznika/EvidencijaPolaznika.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".search {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 20px;\n  border-bottom: 1px solid #d1d9e2;\n  padding-bottom: 20px;\n  margin-bottom: 50px;\n}\n\n.label {\n  border: 1px solid #d8dbdf;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 46px;\n  padding: 0 15px;\n  width: 25%;\n  border-radius: 8px;\n  box-shadow: 0px 0px 50px 0px #5f6d7e1a;\n}\n\n.input {\n  border: none;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: \"Inter\";\n  color: #5f6d7e;\n  width: 90%;\n}\n\n.input::placeholder {\n  font-size: 16px;\n  font-weight: 500;\n  font-family: \"Inter\";\n  color: #9fa7b2;\n}\n\n.input:focus {\n  outline: none;\n}\n\n.searchLabel {\n  font-size: 20px;\n  font-weight: 600;\n  font-family: \"Inter\";\n  color: #4d4d4d;\n}\n\n.info {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  background-color: #ffebeb;\n  border-radius: 8px;\n  padding: 0 20px;\n}\n\n.infoP {\n  font-size: 14px;\n  font-weight: 500;\n  font-family: \"Inter\";\n  color: #5f6d7e;\n}\n\n.input::-webkit-search-cancel-button {\n  -webkit-appearance: none;\n}\n\n.searchContainer {\n  width: 100%;\n}\n\n.dropdown {\n  width: 19.6%;\n  margin-top: 10px;\n  position: absolute;\n  border-radius: 8px;\n  background-color: #ffffff;\n  box-shadow: 0px 0px 10px 5px #5f6d7e1a;\n}\n\n.dropdown:hover {\n  cursor: pointer;\n}\n\n.dropdownItem {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 8px 15px;\n  width: 91%;\n  height: 30px;\n}\n\n.dropdownItem:hover {\n  background-color: #f2f2f2;\n}\n\n.p {\n  font-size: 16px;\n  font-weight: 500;\n  font-family: \"Inter\";\n  color: #5f6d7ec7;\n}\n\n@media screen and (max-width: 1400px) {\n  .dropdown {\n    width: 18%;\n  }\n}\n\n@media screen and (max-width: 1280px) {\n  .dropdown {\n    width: 23%;\n  }\n}\n\n@media screen and (max-width: 1000px) {\n  .dropdown {\n    width: 30%;\n  }\n  .label {\n    width: 34%;\n  }\n}\n\n@media screen and (max-width: 700px) {\n  .dropdown {\n    width: 38%;\n  }\n  .label {\n    width: 45%;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .dropdown {\n    width: 65%;\n  }\n  .label {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: 380px) {\n  .dropdown {\n    width: 63%;\n  }\n  .label {\n    width: 89%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `EvidencijaPolaznika_search__iKbFK`,
	"label": `EvidencijaPolaznika_label__4QwR8`,
	"input": `EvidencijaPolaznika_input__Q9jCh`,
	"searchLabel": `EvidencijaPolaznika_searchLabel__OCt21`,
	"info": `EvidencijaPolaznika_info__6Tufv`,
	"infoP": `EvidencijaPolaznika_infoP__-LktI`,
	"searchContainer": `EvidencijaPolaznika_searchContainer__2BSVK`,
	"dropdown": `EvidencijaPolaznika_dropdown__yqt33`,
	"dropdownItem": `EvidencijaPolaznika_dropdownItem__pqSwh`,
	"p": `EvidencijaPolaznika_p__uA5Mo`
};
export default ___CSS_LOADER_EXPORT___;
